let API_URL;
let AUTH_URL;
let BASE_URL;
let BACKGROUND_URL;
if (process.env.NODE_ENV !== 'development') {
  // API_URL = 'http://esduty.easysmart.cn/api'
  // AUTH_URL = 'http://esdutyauth.easysmart.cn'
  // BASE_URL = 'http://esduty.easysmart.cn'
  // BACKGROUND_URL = 'http://esduty.easysmart.cn/uploads/'
  // API_URL = 'https://zyk.easysmart.cn/api';
  // AUTH_URL = 'https://zyk.easysmart.cn/auth';
  // BASE_URL = 'https://zyk.easysmart.cn';
  // BACKGROUND_URL = 'https://zyk.easysmart.cn/uploads/';
  API_URL = 'http://larb.hep.com.cn/api';
  AUTH_URL = 'http://larb.hep.com.cn/auth';
  BASE_URL = 'http://larb.hep.com.cn';
  BACKGROUND_URL = 'http://larb.hep.com.cn/uploads/';
} else {
  API_URL = 'http://192.168.199.160:5001/api';
  AUTH_URL = 'http://192.168.199.160:5000';
  BACKGROUND_URL = 'http://192.168.199.160:5001/uploads/';
  BASE_URL = 'http://192.168.199.160';
  // API_URL = 'http://192.168.199.160:5001/api'
  // AUTH_URL = 'http://192.168.199.160:5000'
  // BACKGROUND_URL = 'http://192.168.199.160:5001/uploads/'
  // BASE_URL = 'http://beardidi.xicp.net'
}
export default {
  API_URL,
  AUTH_URL,
  BASE_URL,
  BACKGROUND_URL,
};

